import { Extension } from 'tiptap'
import InsertSpaceFillerComponent from './insertSpaceFillerComponent'
// 插入填空符
export default class QuesAppoint extends Extension {
    get name() {
      return 'InsertSpaceFiller';
    }
    menuBtnView ({ isActive, commands, focus, editor }) {
        return {
            component: InsertSpaceFillerComponent,
            componentProps: {
            },
            componentEvents: {
                click: () => {
                    console.log('click')
                    commands.QuesAppoint('______')
                },
            },
        };
    }
}